import { LadzoConsole as Lc } from "../global/ladzo-console.js";
import "vanilla-cookieconsent/dist/cookieconsent.css";
import * as CookieConsent from "vanilla-cookieconsent";

export function zobrazCookieListu() {
  Lc.f("zobrazCookieListu");

  CookieConsent.run({
    root: "body",
    autoShow: true,
    mode: "opt-out", // Umožní zobrazit lištu i bez volitelných cookies
    revision: 1,

    cookie: {
      name: "cc_cookie",
      domain: location.hostname,
      path: "/",
      sameSite: "Lax",
      expiresAfterDays: 182,
    },

    guiOptions: {
      consentModal: {
        layout: "cloud inline",
        position: "bottom center",
        equalWeightButtons: true,
        flipButtons: false,
      },
      preferencesModal: {
        layout: "box",
        equalWeightButtons: true,
        flipButtons: false,
      },
    },

    categories: {
      necessary: {
        enabled: true,
        readOnly: true, // Nelze vypnout
      },
    },

    language: {
      default: "cs",
      translations: {
        cs: {
          consentModal: {
            title: "Používáme cookies",
            description:
              "Používáme cookies, abychom Vám umožnili prohlížení webu. <br>Bez jejich použití by nebylo možné se přihlásit.",
            acceptAllBtn: "Souhlasím",
            //acceptNecessaryBtn: 'OK',
            showPreferencesBtn: "Nastavení",
          },
          preferencesModal: {
            title: "Správa cookies",
            acceptAllBtn: "Povolit vše",
            //acceptNecessaryBtn: 'OK',
            savePreferencesBtn: "Potvrdit nastavení",
            closeIconLabel: "Zavřít",
            sections: [
              {
                title: "Nezbytné cookies",
                description:
                  "Tyto cookies jsou nutné pro správné fungování administrace a nelze je vypnout.",
                linkedCategory: "necessary",
              },
            ],
          },
        },
      },
    },
  });
}
